var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(
            _vm.config.isfStatusOptions.filter(
              (a) => a.value !== 0 && a.value !== -1
            ),
            function (item, $index) {
              return _c(
                "span",
                {
                  directives: [
                    {
                      name: "permissson",
                      rawName: "v-permissson",
                      value: `${item.permissson}`,
                      expression: "`${item.permissson}`",
                    },
                  ],
                  key: item.value,
                  staticClass: "tabItem",
                  class: { active: _vm.activeName === $index },
                  on: {
                    click: function ($event) {
                      return _vm.handleClick($index, item.permissson)
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      item.label +
                        `(${
                          _vm.tabNumer?.find((a) => a.type === +item.value)
                            ?.qty || 0
                        })`
                    ) + " "
                  ),
                ]
              )
            }
          ),
          0
        ),
        _c("div", { staticClass: "opt" }, [
          _vm.filterList.date
            ? _c("div", { staticClass: "checkDate flex_c_c" }, [
                _vm._v(
                  " 查询时间：" +
                    _vm._s(
                      _vm.filterList.date[0] + "~" + _vm.filterList.date[1]
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "btn flex_c_c", on: { click: _vm.newadd } },
            [
              _c("svg-icon", {
                attrs: { className: "icon", iconClass: "add" },
              }),
              _vm._v("新增 "),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "el-popover",
                {
                  ref: "popover",
                  staticClass: "searchPop",
                  attrs: {
                    placement: "top",
                    title: "批量搜索",
                    trigger: "click",
                    width: "378",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "close",
                      on: { click: _vm.closeSearchPanel },
                    },
                    [_c("i", { staticClass: "el-icon-close" })]
                  ),
                  _c("base-muti-input", {
                    ref: "baseMutiInput",
                    attrs: { default: _vm.referenceNumber },
                    model: {
                      value: _vm.referenceNumber,
                      callback: function ($$v) {
                        _vm.referenceNumber = $$v
                      },
                      expression: "referenceNumber",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        margin: "16px 0 0",
                      },
                    },
                    [
                      _c("el-button", { on: { click: _vm.handleEmpty } }, [
                        _vm._v("清空"),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleConfirm },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-input", {
                staticClass: "input-search",
                attrs: {
                  value: _vm.filterList.id,
                  placeholder: "请输入提单/柜号/AMSBLNuber搜索",
                },
                on: { focus: _vm.handleFocus },
              }),
              _c(
                "div",
                { staticClass: "btn-search", on: { click: _vm.handleConfirm } },
                [_c("i", { staticClass: "el-icon-search" })]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "import", on: { click: _vm.exportExcel } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/images/bill/import.png"),
                alt: "",
              },
            }),
            _vm._v("导出 "),
          ]),
          _c(
            "div",
            { staticClass: "filter" },
            [
              _c(
                "base-filter",
                {
                  ref: "BaseFilter",
                  attrs: { isActive: _vm.isActive, width: 504 },
                  on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
                },
                [
                  _c(
                    "div",
                    { staticClass: "filter" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.filterList,
                            "label-width": "104px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "创建日期" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "320px" },
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  align: "center",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "value-format": "yyyy-MM-dd",
                                  "unlink-panels": "",
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.filterList.date,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterList, "date", $$v)
                                  },
                                  expression: "filterList.date",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "客户" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择客户",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.filterList.companyId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterList, "companyId", $$v)
                                    },
                                    expression: "filterList.companyId",
                                  },
                                },
                                _vm._l(_vm.companyDrapdown, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "业务员" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.filterList.saleIds,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterList, "saleIds", $$v)
                                    },
                                    expression: "filterList.saleIds",
                                  },
                                },
                                _vm._l(_vm.userOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                ref: "BaseTable",
                attrs: {
                  height: _vm.height,
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  isEmptyBorder: true,
                  tableData: {
                    ..._vm.tableData,
                    fileds: _vm.fileds,
                  },
                  loading: _vm.loading,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  sortChange: _vm.sortChange,
                  dblclick: (row) => _vm.isfDetail(row),
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "companyName",
                      fn: function (row) {
                        return [
                          row.scope.isPushCompany && row.scope.status === 4
                            ? _c("div", { staticClass: "tips" }, [
                                _c("img", {
                                  staticStyle: { "vertical-align": "-1px" },
                                  attrs: {
                                    src: require("@/assets/images/bill/green-gou.png"),
                                    alt: "",
                                  },
                                }),
                                _vm._v(" 已发送 "),
                              ])
                            : _vm._e(),
                          _vm._v(" " + _vm._s(row.scope.companyName) + " "),
                          row.scope.apiUpdateOn
                            ? _c("span", { staticClass: "tips-date" }, [
                                _vm._v(
                                  " API " + _vm._s(row.scope.apiUpdateOn) + " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "mblNo",
                      fn: function (row) {
                        return [
                          _c(
                            "span",
                            {
                              class: [row.scope.status === 1 ? "" : "link"],
                              on: {
                                click: function ($event) {
                                  return _vm.checkReceipt(row.scope)
                                },
                              },
                            },
                            [
                              _vm._v(" " + _vm._s(row.scope.mblNo) + " "),
                              row.scope.status !== 1
                                ? _c("svg-icon", {
                                    attrs: {
                                      className: "icon",
                                      iconClass: "link",
                                      title: "查看回执",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "importerName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c("div", { staticClass: "conpanyName" }, [
                                _c("span", [_vm._v("公司名")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(row.scope?.importerNameAddress?.name)
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "conpanyName" }, [
                                _c("span", [_vm._v("EIN")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      row.scope?.importerNameAddress?.importer
                                        ?.ein
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.importerNameAddress?.importer
                                        ?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.importerNameAddress?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.importerNameAddress
                                        ?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.importerNameAddress?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.importerNameAddress?.importer
                                      ?.postalCode
                                      ? row.scope.importerNameAddress?.importer
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "manufacturerName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticClass: "conpanyName" }, [
                              _c("span", [_vm._v("公司名")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    row.scope?.manufacturerNameAddress?.name
                                  )
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.manufacturerNameAddress?.scin
                                        ?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.manufacturerNameAddress
                                        ?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.manufacturerNameAddress
                                        ?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.manufacturerNameAddress
                                        ?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.manufacturerNameAddress?.scin
                                      ?.postalCode
                                      ? row.scope.manufacturerNameAddress?.scin
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "sellingName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticClass: "conpanyName" }, [
                              _c("span", [_vm._v("公司名")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(row.scope?.sellingNameAddress?.name)
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.sellingNameAddress?.scin
                                        ?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.sellingNameAddress?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.sellingNameAddress
                                        ?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.sellingNameAddress?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.sellingNameAddress?.scin
                                      ?.postalCode
                                      ? row.scope.sellingNameAddress?.scin
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "buyerName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticClass: "conpanyName" }, [
                              _c("span", [_vm._v("公司名")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(row.scope?.buyerNameAddress?.name)
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.buyerNameAddress?.scin?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.buyerNameAddress?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.buyerNameAddress?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.buyerNameAddress?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.buyerNameAddress?.scin?.postalCode
                                      ? row.scope.buyerNameAddress?.scin
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "shipToPartyName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticClass: "conpanyName" }, [
                              _c("span", [_vm._v("公司名")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    row.scope?.shipToPartyNameAddress?.name
                                  )
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.shipToPartyNameAddress?.scin
                                        ?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.shipToPartyNameAddress
                                        ?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.shipToPartyNameAddress
                                        ?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.shipToPartyNameAddress
                                        ?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.shipToPartyNameAddress?.scin
                                      ?.postalCode
                                      ? row.scope.shipToPartyNameAddress?.scin
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "consolidatorName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticClass: "conpanyName" }, [
                              _c("span", [_vm._v("公司名")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    row.scope?.consolidatorNameAddress?.name
                                  )
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consolidatorNameAddress?.scin
                                        ?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consolidatorNameAddress
                                        ?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consolidatorNameAddress
                                        ?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consolidatorNameAddress
                                        ?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.consolidatorNameAddress?.scin
                                      ?.postalCode
                                      ? row.scope.consolidatorNameAddress?.scin
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "stuffingName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticClass: "conpanyName" }, [
                              _c("span", [_vm._v("公司名")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(row.scope?.stuffingNameAddress?.name)
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.stuffingNameAddress?.scin
                                        ?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.stuffingNameAddress?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.stuffingNameAddress
                                        ?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.stuffingNameAddress?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.stuffingNameAddress?.scin
                                      ?.postalCode
                                      ? row.scope.stuffingNameAddress?.scin
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "consigneeName",
                      fn: function (row) {
                        return [
                          _c("div", { staticClass: "address" }, [
                            _c("div", { staticClass: "conpanyName" }, [
                              _c("span", [_vm._v("公司名")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(row.scope?.consigneeNameAddress?.name)
                                ),
                              ]),
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consigneeNameAddress?.scin
                                        ?.address
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consigneeNameAddress
                                        ?.cityAddress
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consigneeNameAddress
                                        ?.provinceNameEN
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("formatStatusAddress")(
                                      row.scope.consigneeNameAddress
                                        ?.countryCode
                                    )
                                  ) +
                                  " "
                              ),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    row.scope.consigneeNameAddress?.scin
                                      ?.postalCode
                                      ? row.scope.consigneeNameAddress?.scin
                                          ?.postalCode
                                      : ""
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "classification",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                row.scope.classification ? "分单" : "直单"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "onBoardDate",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.onBoardDate)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "requestDate",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.requestDate)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "createdOn",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.createdOn)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "updatedOn",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.updatedOn)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "onFileDate",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.onFileDate)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "acceptedDate",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.acceptedDate)
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "table-opt" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.computedPermissions("跟进记录"),
                                          expression:
                                            "computedPermissions('跟进记录')",
                                        },
                                      ],
                                      staticClass: "opt-item",
                                      attrs: {
                                        "v-permissson":
                                          _vm.computedPermissions("跟进记录"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewLog(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v("跟进记录")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.computedPermissions("修改"),
                                          expression:
                                            "computedPermissions('修改')",
                                        },
                                      ],
                                      staticClass: "opt-item",
                                      attrs: {
                                        "v-permissson":
                                          _vm.computedPermissions("修改"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.fillIsf(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v("修改")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.computedPermissions("同步"),
                                          expression:
                                            "computedPermissions('同步')",
                                        },
                                      ],
                                      staticClass: "opt-item",
                                      attrs: {
                                        "v-permissson":
                                          _vm.computedPermissions("同步"),
                                        disabled: row.scope.isSynchronous,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.synchronousISF(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v("同步")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.computedPermissions("取消"),
                                          expression:
                                            "computedPermissions('取消')",
                                        },
                                      ],
                                      staticClass: "opt-item",
                                      attrs: {
                                        "v-permissson":
                                          _vm.computedPermissions("取消"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.cancelIsf(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.computedPermissions("查看文件"),
                                          expression:
                                            "computedPermissions('查看文件')",
                                        },
                                      ],
                                      staticClass: "opt-item",
                                      attrs: {
                                        "v-permissson":
                                          _vm.computedPermissions("查看文件"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewFile(row.scope)
                                        },
                                      },
                                    },
                                    [_vm._v("查看文件")]
                                  ),
                                ],
                                1
                              ),
                              _c("img", {
                                staticStyle: { "margin-left": "-14px" },
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2691733743
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("add-isf-drawer", {
        attrs: {
          drawer: _vm.drawer,
          companyList: _vm.companyDrapdown,
          shipmentFileNumber: _vm.shipmentFileNumber,
          rowData: _vm.rowData,
        },
        on: {
          close: _vm.close,
          ok: function ($event) {
            _vm.drawer = false
            _vm.getList(_vm.pagerConfig)
          },
        },
      }),
      _c("isf-detail-drawer", {
        attrs: { drawer: _vm.drawer2, rowData: _vm.rowData },
        on: { close: _vm.close },
      }),
      _c("isf-receipt-drawer", {
        attrs: {
          drawer: _vm.drawer3,
          shipmentFileNumber: _vm.shipmentFileNumber,
          blNo: _vm.blNo,
          row: _vm.row,
          containerNumber: _vm.containerNumber,
        },
        on: { close: _vm.close },
      }),
      _c("IsfErrorDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible,
          errorMessage: _vm.isfError.errorMessage,
          shipmentFileNumber: _vm.isfError.shipmentFileNumber,
        },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible = false
          },
        },
      }),
      _c("EmailsDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1, isfData: _vm.isfData },
        on: {
          ok: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("follow-up-records-drawer", {
        attrs: {
          drawer: _vm.drawer5,
          rowData: {
            id: _vm.rowData.mblId,
          },
          showFinance: false,
          "bill-type": 0,
        },
        on: {
          close: function ($event) {
            _vm.drawer5 = false
            _vm.getList(_vm.pagerConfig)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }